import { render, staticRenderFns } from "./inconsistencyResult .vue?vue&type=template&id=159ab6f3&scoped=true&"
import script from "./inconsistencyResult .vue?vue&type=script&lang=js&"
export * from "./inconsistencyResult .vue?vue&type=script&lang=js&"
import style0 from "./inconsistencyResult .vue?vue&type=style&index=0&id=159ab6f3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159ab6f3",
  null
  
)

export default component.exports